import api from '../../server';
import{decrypt,getCookie} from "../../utils"

export default {
  namespaced: true,
  state: {
    neworder: getCookie("neworder") !== undefined&&getCookie("neworder") !== "" ? JSON.parse(decrypt(getCookie("neworder"))) : {},
    orderpay:{},
    orderdata:{}
  },
  actions:{
    fetchCreateOrder({commit}, {params}) {
      return api.Create(params).then(data => commit('setCreateOrder', {data}))
    },
    fetchCreateData({commit}, {params}) {
      return api.createOrder(params).then(data => commit('setOrderData', {data}))
    },
    fetchOrderPay({commit}, {params}) {
      return api.OrderPay(params).then(data => commit('setOrderPay', {data}))
    }
  },
  mutations: {
    setCreateOrder(state,data){
      state.neworder = data.data.data
    },
    setOrderPay(state,data){
      state.orderpay = data.data
    },
    setOrderData(state,data){
      state.orderdata = data.data.data
    }
  }
}
